import PRODUCT_CONSTANTS from '../constants/product-constants';
import { ProductAction } from '../types/product-types'
import { ProductModel, PaginatedProductModel } from './../../models/product-model';

export interface ProductsReducerState {
    searchProducts: any;
    product: ProductModel;
    paginatedProducts: PaginatedProductModel;
    featuredProducts: Array<ProductModel>;
    frontPageProducts: {
        mostPurchasedProducts: Array<ProductModel>;
        latestProducts: Array<ProductModel>;
        displayMostPurchasedTitle: boolean;
    };
    loading: boolean;
    error: any;
}

const initialState: ProductsReducerState = {
    searchProducts: [],
    product: {} as ProductModel,
    paginatedProducts: {} as PaginatedProductModel,
    featuredProducts: [],
    frontPageProducts: {
        mostPurchasedProducts: [],
        latestProducts: [],
        displayMostPurchasedTitle: false
    },
    loading: false,
    error: undefined
}

export const productReducer = (state = initialState, action: ProductAction) => {
    switch (action.type) {
        case PRODUCT_CONSTANTS.FETCH_PRODUCT_CATALOG_REQUEST:
            return {
                ...state,
                loading: true
            };

        case PRODUCT_CONSTANTS.FETCH_PRODUCT_CATALOG_SUCCESS:
            return {
                ...state,
                loading: false,
                paginatedProducts: action.data
            };
        
        case PRODUCT_CONSTANTS.FETCH_PRODUCT_CATALOG_FAIL:
            return { 
                ...state,
                loading: false,
                error: action.error
            };
        
        case PRODUCT_CONSTANTS.FETCH_FRONT_PAGE_PRODUCTS_REQUEST:
            return {
                ...state,
                frontPageProducts: {
                    mostPurchasedProducts: [],
                    latestProducts: [],
                    displayMostPurchasedTitle: false
                },
                loading: true
            };

        case PRODUCT_CONSTANTS.FETCH_FRONT_PAGE_PRODUCTS_SUCCESS:
            return {
                ...state,
                loading: false,
                frontPageProducts: action.data
            };
        
        case PRODUCT_CONSTANTS.FETCH_FRONT_PAGE_PRODUCTS_FAIL:
            return { 
                ...state,
                loading: false,
                error: action.error
            };
        case PRODUCT_CONSTANTS.PRODUCT_DETAILS_REQUEST:
            return {
                ...state,
                product: {} as ProductModel,
                featuredProducts: [],
                loading: true,
                error: undefined
            };

        case PRODUCT_CONSTANTS.PRODUCT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                product: action.data.product,
                featuredProducts: action.data.featuredProducts,
                error: undefined
            };
        
        case PRODUCT_CONSTANTS.PRODUCT_DETAILS_FAIL:
            return { 
                ...state,
                loading: false,
                error: action.error
            };
        
        case PRODUCT_CONSTANTS.SEARCH_PRODUCT_REQUEST:
            return {
                ...state,
                loading: true,
                searchProducts: []
            };

        case PRODUCT_CONSTANTS.SEARCH_PRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                searchProducts: action.data
            };
        
        case PRODUCT_CONSTANTS.SEARCH_PRODUCT_FAIL:
            return { 
                ...state,
                loading: false,
                error: action.error
            };

        case PRODUCT_CONSTANTS.CLEAN_PRODUCT_CATALOG:
            return {
                ...state,
                loading: false,
                paginatedProducts: {} as PaginatedProductModel
            };

        default:
            return state;
    }
}